export function range(n) {
    var out = new Float32Array(n);
    for (var i = 0; i < n; i++) {
        out[i] = i;
    }
    return out;
}
/**
 * Convert integer to float for shaders.
 */
export function float(i) {
    return i.toFixed(1);
}
